import React, { useState, useEffect } from "react";
import homeImg from "../assets/images/home-img.png";
import vedantaClass from "../assets/images/vedanta class.png";
import tamilTalsk from "../assets/images/tamil talks.png";
import generalTalks from "../assets/images/general talks.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Import Swiper core styles
import "swiper/css/navigation"; // Import Navigation styles
import "swiper/css/pagination"; // Import Pagination styles
import { Card, CardMedia, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom"; // Assuming you use react-router for navigation
// Import Swiper core and required modules
import { Navigation, Pagination } from "swiper/modules";
import "../styles/Swiper.css";
import ScrollReveal from "scrollreveal";

const images = [
  {
    src: vedantaClass, // Replace with your image URL
    alt: "Image 1",
    label: "Vedanta Classes",
    link: "#",
    tracks: "82 Topics | 559 Volumes", // Replace with your hyperlink
  },
  {
    src: tamilTalsk,
    alt: "Image 2",
    label: "Tamil Talks",
    link: "#",
    tracks: "1 Topics | 9 Volumes",
  },
  {
    src: generalTalks,
    alt: "Image 3",
    label: "General Talks",
    link: "#",
    tracks: "1 Topics | 11 Volumes",
  },
];

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const HomePage = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  useEffect(() => {
    ScrollReveal().reveal(".reveal1", {
      duration: 2000, // Animation duration (in ms)
      distance: "50px", // Distance the element moves
      origin: "bottom", // Animation starts from the bottom
      easing: "ease-in-out", // Easing for the animation
      delay: "300"
    });
    ScrollReveal().reveal(".reveal2", {
      duration: 2000, // Animation duration (in ms)
      distance: "50px", // Distance the element moves
      origin: "bottom", // Animation starts from the bottom
      easing: "ease-in-out", // Easing for the animation
      delay: "500"
    });
    ScrollReveal().reveal(".reveal3", {
      duration: 2000, // Animation duration (in ms)
      distance: "50px", // Distance the element moves
      origin: "bottom", // Animation starts from the bottom
      easing: "ease-in-out", // Easing for the animation
      delay: "700"
    });
  }, []);

  return (
    <>
      {/* Swiper images */}
      <div style={{ minHeight: "100vh" }}>
        <div
          className="swiper-container reveal1"
          style={{ width: "100%", height: "auto" }}
        >
          <Swiper
            modules={[Navigation, Pagination]} // Use modules here
            spaceBetween={30}
            slidesPerView={1}
            navigation // Enable navigation arrows
            pagination={{ clickable: true }} // Enable pagination dots
            loop // Enable infinite loop
            autoplay={{ delay: 3000 }} // Autoplay every 3 seconds
          >
            <SwiperSlide>
              <img
                src={homeImg}
                alt="home-img"
                style={{ width: "100%", height: "auto" }}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={homeImg}
                alt="home-img"
                style={{ width: "100%", height: "auto" }}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={homeImg}
                alt="home-img"
                style={{ width: "100%", height: "auto" }}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={homeImg}
                alt="home-img"
                style={{ width: "100%", height: "auto" }}
              />
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="container-sm">
          <h2
            className="reveal2"
            style={{ textAlign: "center", color: "#495057" }}
          >
            Vedānta Talks by HH Swami Paramarthananda Saraswathi
          </h2>
          <p
            style={{
              textAlign: "center",
            }}
            className="reveal2"
          >
            Search, select and purchase discourses on Vedānta and chantings
            delivered by HH Swami Paramarthananda Saraswathi. Choose from a wide
            range of categories, make your wish list and access your purchased
            discourses and chantings from your account.
          </p>

          <div style={styles.container} className="reveal3">
            {images.map((image, index) => (
              <Card
                key={index}
                style={{
                  ...styles.card,
                  // transform: hoveredIndex === index ? "scale(1.05)" : "scale(1)",
                  transform:
                    hoveredIndex === index ? "scale(1.01)" : "scale(1)",
                  boxShadow: hoveredIndex === index ? "0 4px 15px #8C3A00" : "",
                }}
                className="reveal3"
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to={image.link}
                  style={{ textDecoration: "none", color: "inherit" }}
                  onClick={scrollToTop}
                >
                  <CardMedia
                    component="img"
                    image={image.src}
                    alt={image.alt}
                    style={{
                      ...styles.media,
                    }}
                  />
                  <CardContent>
                    <Typography
                      variant="h6"
                      component="div"
                      style={styles.label}
                    >
                      {image.label}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {image.tracks}
                    </Typography>
                  </CardContent>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

// Inline styles for the component
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap", // Allows items to wrap on smaller screens
    gap: "20px",
    margin: "0 auto", // Centers the flex container
    padding: "20px",
    // maxWidth: "1200px", // Max width for larger screens
  },
  card: {
    backgroundColor: "#F5F5F5", // Card background color
    textAlign: "center",
    margin: "10px",
    flex: "1 1 calc(33% - 40px)", // Takes up 1/3 of the row minus gap space
    minWidth: "250px", // Minimum width before wrapping occurs
    maxWidth: "300px", // Maximum width for cards
    borderRadius: "10px",
    overflow: "hidden", // Ensure no overflow from scaling
    transition: "transform 0.3s ease-in-out", // Smooth transition for the scaling effect
    position: "relative",
  },
  media: {
    height: 300, // Adjust height as needed
    borderRadius: "8px",
    transition: "transform 0.3s ease-in-out", // Smooth transition for scaling effect on hover
  },
  label: {
    marginTop: "10px", // Space between image and label
    fontSize: "16px",
    color: "#495057",
  },
  "@media (max-width: 600px)": {
    container: {
      flexDirection: "column", // Stack images one by one
      alignItems: "center", // Center-align items on smaller screens
    },
    card: {
      flexBasis: "100%", // Full width on smaller screens
    },
  },
  hoverEffect: {
    "&:hover $media": {
      transform: "scale(1.1)", // Scale image by 10% on hover
      boxShadow: "0 4px 15px #8C3A00",
    },
  },
};

export default HomePage;
